import React, { useCallback, useContext } from 'react'
import MuiSnackbar from '@mui/material/Snackbar'
import styles from '../../styles'
import DoneOutlineIcon from '@mui/icons-material/DoneOutline'
import { ResponsiveContext } from '../../utils/context/ResponsiveContext'
import { makeStyles } from 'tss-react/mui'
import { AUTO_HIDE_DURATION, BOTTOM, CENTER, SNACKBAR_CLOSE_REASON } from './utils/SnackBarConstants'
import { SnackBarContext } from './context/SnackBarContext'

const useStyles = makeStyles<{ isLargeScreen: boolean }>()((theme, { isLargeScreen }) => ({
	...styles(theme),
	snackBarStyle: {
		width: isLargeScreen ? '50%' : '100%',
		wordBreak: 'break-word'
	},
	verticalBottom: {
		verticalAlign: 'bottom',
		marginRight: '20px'
	}
}))

const SnackBar: React.FC = () => {
	const { isLargeScreen } = useContext(ResponsiveContext)
	const { classes } = useStyles({ isLargeScreen })
	const { snackBarData, hideSnackBar } = useContext(SnackBarContext)

	const handleClose = useCallback((event: any, reason: any) => {
		if (reason !== SNACKBAR_CLOSE_REASON) {
			hideSnackBar()
		}
	}, [hideSnackBar])

	return (
		<>
			<MuiSnackbar
				className={classes.snackBarStyle}
				anchorOrigin={{ vertical: BOTTOM, horizontal: CENTER }}
				key={snackBarData.id}
				open={snackBarData.open}
				autoHideDuration={AUTO_HIDE_DURATION}
				onClose={handleClose}
				ContentProps={{
					'aria-describedby': snackBarData.id
				}}
				message={
					<span id={snackBarData.id}>
						{!snackBarData.hideIcon && <DoneOutlineIcon className={classes.verticalBottom} />}
						<span className={[classes.text4, classes.colorWhite].join(' ')}>
							{snackBarData.message}
						</span>
					</span>
				}
			/>
		</>
	)
}

export default SnackBar
